
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/listing",
      function () {
        return require("private-next-pages/listing/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/listing"])
      });
    }
  